import React, { Component } from "react";
import { Card, Button, Spinner, Container } from "react-bootstrap";
import ClusterRanking from "./cluster_ranking";
import AreaRanking from "./area_ranking";
import { connect } from "react-redux";

import { DatePicker } from "@material-ui/pickers";

import {
  SetPreviousMonthAverageSetScopeDate,
  GetPreviousMonthAverageAreaV4,
  GetPreviousMonthAverageClusterV4,
} from "../../../../store/actions/reports-v4/previous_month_average_service_actions";

import {
  GetMasterClusters,
  GetMasterAreas,
  GetPeppHierarchy,
} from "../../../../store/actions/crdm_service_actions";

import moment from "moment";
import { DashboardContext } from "../../dashboard_context";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import { moduleNames } from "../../../../helpers/dashboardModuleNames";
import BranchRanking from "./branch_ranking";
import BranchRankingSpecific from "./branch_ranking_specific";
import { RankingContext } from "./ranking_context";

const cluster_ranking_col = [
  {
    id: 1,
    name: "Rank",
  },
  {
    id: 2,
    name: "Name",
  },
  {
    id: 3,
    name: (
      <>
        Total <span className="text-secondary small">[Piece/Amount]</span>
      </>
    ),
  },
];

const area_ranking_col = [
  {
    id: 1,
    name: "Rank",
  },
  {
    id: 2,
    name: "Name",
  },
  {
    id: 3,
    name: (
      <>
        Total <span className="text-secondary small">[Piece/Amount]</span>
      </>
    ),
  },
];

const ranking_title_defaults = {
  view_cluster: "cluster",
  view_cluster_description:
    "Average pawns accepted of all clusters for the month of",
  view_branch: "branch",
  view_branch_description: "Of Top 10 Branches under area from ",
  view_area: "area",
};

class RankingView extends Component {
  state = {
    current_view: ranking_title_defaults.current_view,
    current_view_text: ranking_title_defaults.view_cluster_description,
    cluster_headers: cluster_ranking_col,
    area_headers: area_ranking_col,
    area_codes: [],
    branch_codes: [],
    rankingPeriod: null,

    isLoading: false,

    isRankingDateFilterOpen: false,
  };

  componentDidMount() {
    this.appendItemData();
  }

  startLoading = () => {
    this.setState({ isLoading: true });
  };

  endLoading = () => {
    this.setState({ isLoading: false });
  };

  appendItemData = () => {
    this.startLoading();
    this.premiseGetMasterAreas();
    this.premiseGetMasterClusters().then((_) => {
      let { master_cluster } = this.props;
      let cluster_id_list = master_cluster.map((d) => d.id);
      this.premiseGetPeppHeirarchy({
        cluster_ids: cluster_id_list,
      });
      this.premiseGetPreviousMonthAverageCluster({
        month: this.props.pma_month,
        year: this.props.pma_year,
        cluster_ids: cluster_id_list,
      }).then((r) => {
        this.endLoading();
      });
    });
  };

  handleGotoBranchView = (data) => {
    this.setState({
      area_codes: data.areas,
      branch_codes: data.branches.map((br) => br.branchCode),
    });

    var currentArea = data.cluster[0].branchesByArea.find(
      (x) => x.areaCode === data.areas[0]
    );

    this.props.handleRankingTitles({
      current_view: "branch",
      current_view_text: (
        <>
          {" "}
          Of Top 10 Branches under{" "}
          <span className="text-danger">
            {`${currentArea.areaName} (${data.areas[0]})`}
          </span>{" "}
          from
        </>
      ),
    });
  };

  handleGotoAreaView = (data) => {
    this.setState({
      area_codes: data.areas,
    });

    this.props.handleRankingTitles({
      current_view: "area",
      current_view_text: (
        <>
          Of Areas under{" "}
          <span className="text-danger">{data.cluster.name}</span> from
        </>
      ),
    });
  };

  handleGotoClusterView = () => {
    this.props.handleRankingTitles({
      current_view: ranking_title_defaults.view_cluster,
      current_view_text: ranking_title_defaults.view_cluster_description,
    });
  };

  renderOptions = () => {
    return (
      <>
        <DatePicker
          disableFuture
          disableToolbar
          onClose={() => {
            this.setState({ isRankingDateFilterOpen: false });
          }}
          onChange={this.premiseSetPreviousMonthAverageSetScopeDate}
          value={this.state.rankingPeriod}
          hidden={true}
          views={["year", "month"]}
          openTo="year"
          variant="dialog"
          format="MMMM YYYY"
          open={this.state.isRankingDateFilterOpen}
        />
        <div className="align-content-between">
          <div>
            <small>{this.context.current_view_text}</small>
            <Button
              size="sm"
              variant="link"
              onClick={() => {
                this.setState({
                  isRankingDateFilterOpen: true,
                });
              }}
            >
              {/* {moment(
                this.state.rankingPeriod !== null
                  ? this.state.rankingPeriod
                  : new Date(this.props.pma_year, this.props.pma_month - 1)
              ).format("MMMM YYYY")} */}
              {this.context.current_view == ranking_title_defaults.view_area ||
              this.context.current_view == ranking_title_defaults.view_branch
                ? this.handleEnclosedDateView(
                    this.props.pma_year,
                    this.props.pma_month
                  )
                : moment(
                    new Date(this.props.pma_year, this.props.pma_month, 0)
                  ).format("MMMM YYYY")}
            </Button>
          </div>
          <div className="float-right">
            <ModuleLocked
              Lock={() => this.context.Lock(moduleNames.ranking)}
              Unlock={() => this.context.Unlock(moduleNames.ranking)}
              isLocked={this.context.rankingLocked}
            />
          </div>
          <Container>
            <Button
              hidden={this.context.current_view !== "cluster"}
              disabled={this.state.isLoading}
              onClick={() => {
                this.startLoading();
                let { master_area } = this.props;
                let codes = master_area.map((ar) => ar.areaCode);
                this.premiseGetPreviousMonthAverageArea({
                  month: this.props.pma_month,
                  year: this.props.pma_year,
                  area_codes: codes,
                }).then((r) => {
                  this.setState({
                    area_codes: codes,
                  });
                  this.props.handleRankingTitles({
                    current_view_text:
                      "Overall Area Piece and Principal list as of",
                    current_view: "area",
                  });

                  this.endLoading();
                });
              }}
              size="sm"
              variant="secondary"
            >
              <span>
                Overall Area Ranking
                {this.state.isLoading && (
                  <Spinner className="ml-2 mt-1" size="sm" animation="border" />
                )}
              </span>
            </Button>
          </Container>
        </div>
      </>
    );
  };

  ///0-january, 1-february, 2-march etc.
  handleEnclosedDateView = (year, month) => {
    const day =
      month - 1 === new Date().getMonth() && year === new Date().getFullYear()
        ? new Date().getDate()
        : new Date(year, month, 0).getDate();

    return `${moment(new Date(year, month - 1, 1)).format("MMMM DD, YYYY")} to  
      ${moment(new Date(year, month - 1, day)).format("MMMM DD, YYYY")}`;
  };

  render_default_view = () => {
    return <div>Please Wait</div>;
  };

  renderCurrentView = () => {
    switch (this.context.current_view) {
      case "cluster":
        return <ClusterRanking />;

      case "area":
        return <AreaRanking {...this.state} />;

      case "branch":
        return <BranchRanking {...this.state} />;

      case "branch_specific":
        return <BranchRankingSpecific {...this.state} />;

      default:
        return this.render_default_view();
    }
  };

  render() {
    return (
      <RankingContext.Provider
        value={{
          state: this.state,
          area_codes: this.context.area_codes,
          branch_codes: this.context.branch_codes,
          gotoBranchView: this.handleGotoBranchView,
          gotoAreaView: this.handleGotoAreaView,
          gotoClusterView: this.handleGotoClusterView,
        }}
      >
        <Card.Body>
          <Card.Title as="h4" style={{ color: "#0D47A1" }}>
            Average Pawns Accepted
          </Card.Title>
          <Card.Subtitle>{this.renderOptions()}</Card.Subtitle>
          {this.renderCurrentView()}
        </Card.Body>
      </RankingContext.Provider>
    );
  }

  premiseSetPreviousMonthAverageSetScopeDate = (e) => {
    var momentDate = moment(e);
    var month = momentDate.month() + 1;
    var year = momentDate.year();
    this.props.SetPreviousMonthAverageSetScopeDate({
      month: month,
      year: year,
    });

    this.setState(
      {
        rankingPeriod: momentDate,
        isRankingDateFilterOpen: false,
      },
      () => {
        this.appendItemData();
      }
    );

    console.log(`RankingPeriod: `, this.state.rankingPeriod);
  };

  premiseGetPeppHeirarchy = (data) => {
    return this.props.GetPeppHierarchy(data);
  };

  premiseGetPreviousMonthAverageCluster = (data) => {
    return this.props.GetPreviousMonthAverageClusterV4(data);
  };

  premiseGetPreviousMonthAverageArea = (data) => {
    return this.props.GetPreviousMonthAverageAreaV4(data);
  };

  premiseGetMasterClusters = () => {
    return this.props.GetMasterClusters();
  };

  premiseGetMasterAreas = () => {
    return this.props.GetMasterAreas();
  };
}

const mapStateToProps = (state) => {
  return {
    clusterSummaries: state.previous_month_average.clusterSummaries,

    pma_month: state.previous_month_average.pma_month,
    pma_year: state.previous_month_average.pma_year,

    areaSummaries: state.previous_month_average.areaSummaries,
    master_cluster: state.crdm.master_cluster,
    master_area: state.crdm.master_area,
    pepp_hierarchy: state.crdm.pepp_hierarchy,
  };
};

const mapDispatchToProps = {
  SetPreviousMonthAverageSetScopeDate: SetPreviousMonthAverageSetScopeDate,
  GetPreviousMonthAverageAreaV4: GetPreviousMonthAverageAreaV4,
  GetPreviousMonthAverageClusterV4: GetPreviousMonthAverageClusterV4,
  GetMasterClusters: GetMasterClusters,
  GetMasterAreas: GetMasterAreas,
  GetPeppHierarchy: GetPeppHierarchy,
};

RankingView.contextType = DashboardContext;

export default connect(mapStateToProps, mapDispatchToProps)(RankingView);
